// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const markNotificationAsRead = async ({
    test,
    notificationId,
}: {
    test: boolean,
    notificationId: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleMarkNotificationAsRead = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        boolean
    >(
        functions,
        'markNotificationAsRead',
    );
    return handleMarkNotificationAsRead({
        test,
        notificationId,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default markNotificationAsRead;
